import { motion } from 'framer-motion';

export function ContactSection() {
  return (
    <section id="contact" className="py-20 sm:py-24 md:py-28 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Side - Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <div className="inline-flex items-center gap-3 bg-[#FF8E53]/10 px-6 py-3 rounded-full mb-6 sm:mb-8">
              <i className="ri-customer-service-2-line text-[#FF8E53] text-lg sm:text-xl"></i>
              <span className="text-[#FF8E53] text-base sm:text-lg font-medium">Contact Us</span>
            </div>
            
            <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-[#2C2C2C] mb-6 sm:mb-8 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              제주 여행의<br />
              새로운 기준
            </h2>
            
            <p className="text-xl sm:text-2xl text-gray-600 leading-relaxed mb-10">
              로컬 전문가 1위<br />
              고객 만족도 4.9/5.0<br />
              재방문율 92%
            </p>

            {/* Statistics */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6 mb-10">
              <div className="text-center p-4 sm:p-6 bg-gradient-to-br from-[#0E7FC0] to-[#0a5f92] rounded-2xl text-white shadow-lg">
                <div className="text-3xl sm:text-4xl font-bold mb-2">1위</div>
                <div className="text-sm sm:text-base">로컬 전문성</div>
              </div>
              <div className="text-center p-4 sm:p-6 bg-gradient-to-br from-[#4A7C59] to-[#3a6347] rounded-2xl text-white shadow-lg">
                <div className="text-3xl sm:text-4xl font-bold mb-2">1위</div>
                <div className="text-sm sm:text-base">맞춤 서비스</div>
              </div>
              <div className="text-center p-4 sm:p-6 bg-gradient-to-br from-[#FF8E53] to-[#ff7a3d] rounded-2xl text-white shadow-lg">
                <div className="text-3xl sm:text-4xl font-bold mb-2">1위</div>
                <div className="text-sm sm:text-base">고객 만족</div>
              </div>
            </div>
          </motion.div>

          {/* Right Side - Contact Cards */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="space-y-4 sm:space-y-6"
          >
            <div className="flex items-center gap-4 sm:gap-6 bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#0E7FC0]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-smartphone-line text-[#0E7FC0] text-2xl sm:text-3xl"></i>
              </div>
              <div>
                <div className="text-base sm:text-lg text-gray-600 mb-1">휴대폰</div>
                <a href="tel:010-5685-7818" className="text-xl sm:text-2xl font-bold text-[#2C2C2C] hover:text-[#0E7FC0] transition-colors">
                  010-5685-7818
                </a>
              </div>
            </div>

            <div className="flex items-center gap-4 sm:gap-6 bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#4A7C59]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-phone-line text-[#4A7C59] text-2xl sm:text-3xl"></i>
              </div>
              <div>
                <div className="text-base sm:text-lg text-gray-600 mb-1">전화</div>
                <a href="tel:064-782-7818" className="text-xl sm:text-2xl font-bold text-[#2C2C2C] hover:text-[#4A7C59] transition-colors">
                  064-782-7818
                </a>
              </div>
            </div>

            <div className="flex items-center gap-4 sm:gap-6 bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#FF8E53]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-printer-line text-[#FF8E53] text-2xl sm:text-3xl"></i>
              </div>
              <div>
                <div className="text-base sm:text-lg text-gray-600 mb-1">팩스</div>
                <div className="text-xl sm:text-2xl font-bold text-[#2C2C2C]">
                  050-4258-7818
                </div>
              </div>
            </div>

            <div className="flex items-center gap-4 sm:gap-6 bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-purple-600 text-2xl sm:text-3xl"></i>
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-base sm:text-lg text-gray-600 mb-1">이메일</div>
                <a href="mailto:jejuvely@gmail.com" className="text-lg sm:text-xl font-bold text-[#2C2C2C] hover:text-purple-600 transition-colors break-all">
                  jejuvely@gmail.com
                </a>
              </div>
            </div>

            <div className="flex items-center gap-4 sm:gap-6 bg-white p-6 sm:p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-14 h-14 sm:w-16 sm:h-16 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                <i className="ri-global-line text-teal-600 text-2xl sm:text-3xl"></i>
              </div>
              <div>
                <div className="text-base sm:text-lg text-gray-600 mb-1">홈페이지</div>
                <a href="http://www.jejuvely.com" target="_blank" rel="noopener noreferrer" className="text-lg sm:text-xl font-bold text-[#2C2C2C] hover:text-teal-600 transition-colors">
                  www.jejuvely.com
                </a>
              </div>
            </div>

            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 sm:p-8 border-2 border-gray-200">
              <div className="flex items-center gap-3 sm:gap-4 mb-3">
                <i className="ri-time-line text-2xl sm:text-3xl text-gray-700"></i>
                <span className="text-base sm:text-lg font-bold text-gray-700">상담 시간</span>
              </div>
              <p className="text-xl sm:text-2xl font-bold text-[#2C2C2C] mb-2">매일 08:00 - 22:00</p>
              <p className="text-base sm:text-lg text-gray-600">주말 및 공휴일도 상담 가능</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
